// Toma automáticamente TODAS las fotos de src/media/images.
// No hay listas ni JSON: soltás un archivo en esa carpeta y aparece en el carrusel.
const context = require.context('../media/images', false, /\.(jpe?g|png|gif|webp|svg)$/i);

const images = context
  .keys()
  .sort()
  .map((key) => {
    const mod = context(key);
    const src = mod && mod.default ? mod.default : mod;
    const filename = key.replace(/^.*[\\/]/, '');
    const alt = filename
      .replace(/\.(jpe?g|png|gif|webp|svg)$/i, '')
      .replace(/[-_]+/g, ' ')
      .replace(/([A-Z])/g, ' $1')
      .trim();
    return { src, alt };
  });

export default images;
